import { createAsyncTypes } from '../Utilities'

export const GET_BLOG_ASYNC = createAsyncTypes('GET_BLOG')
